// extracted by mini-css-extract-plugin
export default {"sort":"DT-z","sortSelect":"ET-z","disabled":"FT-z"};